import createReactComponent from '../createReactComponent';
export default createReactComponent('tent', 'IconTent', [
  ['path', { d: 'M11 14l4 6h6l-9 -16l-9 16h6l4 -6', key: 'svg-0' }],
]);
